var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3558 4.41216C13.3643 4.53874 13.3643 4.66531 13.3643 4.79305C13.3643 8.68534 10.475 13.1743 5.19183 13.1743V13.172C3.63115 13.1743 2.1029 12.7159 0.789062 11.8514C1.016 11.8794 1.24407 11.8934 1.47271 11.894C2.76607 11.8952 4.02246 11.4501 5.03997 10.6306C3.81088 10.6067 2.73308 9.78484 2.35656 8.58502C2.78711 8.67018 3.23074 8.65268 3.65333 8.53427C2.31334 8.25662 1.34929 7.04921 1.34929 5.64699C1.34929 5.63415 1.34929 5.62191 1.34929 5.60966C1.74856 5.83772 2.1956 5.9643 2.65289 5.9783C1.39081 5.11328 1.00178 3.39141 1.76392 2.04518C3.22221 3.88545 5.37383 5.0042 7.68356 5.12261C7.45207 4.09952 7.7683 3.02743 8.51451 2.30824C9.67137 1.19299 11.4908 1.25015 12.5783 2.43598C13.2216 2.30591 13.8381 2.06384 14.4023 1.72087C14.1879 2.40273 13.7391 2.98194 13.1397 3.34999C13.709 3.28117 14.2652 3.12484 14.7891 2.88628C14.4034 3.4789 13.9177 3.99511 13.3558 4.41216Z",
    fill: "#1D9BF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.1a752bc599b4ff16c2d62f59e341b466.svg";
export { ForwardRef as ReactComponent };